import React, { useState } from 'react';

const Accordion = ({ title, content }) => {
  const [isOpen] = useState(true);

  return (
    <div className="w-[285px]">
      <div className="cursor-pointer flex place-self-center pl-2 pt-2">
        <h2 className="text-14 font-medium">{title}</h2>
      </div>
      {isOpen && <div className="bg-white">{content}</div>}
    </div>
  );
};

export default Accordion;
